import { useMemo } from 'react'

import { ContentSkeleton } from './ContentSkeleton'
import { decodeHtml } from '../../../../Theme'
import { SectionHeader } from '../../../../UiBlocks'
import { useProductAttributes } from '../../../state'
import { Brands } from '../ProductInfo/Brands'
import { SafetyStihl } from '../ProductInfo/SafetyStihl'

interface DescriptionContentProps {
  /** Decoded description HTML */
  html: string
  logoUrl: string | undefined
}

function DescriptionContent({ html, logoUrl }: DescriptionContentProps) {
  return (
    <div className="bg-white xl:mb-5 mb-2 mt-5" id="productDescription">
      <SectionHeader size="lg" as="h2" className="!leading-[50px] pl-10 pr-10">
        Descriere
      </SectionHeader>
      <div className="overflow-auto max-h-[500px] p-3 border-2 border-solid border-cards-bg flex flex-col items-start">
        <div className="flex flex-col md:flex-row items-center bg-cards-bg border-solid border-y-4 border-white xl:border-0 w-full">
          <div className="w-full md:w-1/3">
            <Brands logoUrl={logoUrl} />
          </div>
          <div className="w-full md:w-2/3">
            <SafetyStihl />
          </div>
        </div>
        <div
          className="font-main-font text-sm xl:text-base w-full"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  )
}

export function Description() {
  const { description, productInfoConfig, loadingDescription } = useProductAttributes()

  const decodedDescription = useMemo(() => {
    return description ? decodeHtml(description) : null
  }, [description])

  if (loadingDescription) {
    return <ContentSkeleton section="description" />
  }

  if (!decodedDescription) {
    return null
  }

  return (
    <DescriptionContent
      html={decodedDescription}
      logoUrl={productInfoConfig.attributes?.logoUrl}
    />
  )
}
